/** Load the combined AE metric cards + per-team rows for one or more teams (By-Team mode). */
export class LoadTeamSummary {
  static readonly type = '[TeamSummary] Load Team Summary';
  constructor(
    public teamIds: number[],
    public overrideCache = false
  ) {}
}
